// extracted by css-extract-rspack-plugin
export default {"content":"content--IAmYYybeIXQv5D_v","img":"img--UfnkPazYCr851s8M"};